import React from "react";
import OutputString from "./type/OutputString";
import OutputDate from "./type/OutputDate";
import OutputBoolean from "./type/OutputBoolean";
import OutputImage from "./type/OutputImage";
import OutputPointer from "./type/OutputPointer";
import OutputArray from "./type/OutputArray";
import OutputRelation from "./type/OutputRelation";

function OutputFactory({
  type,
  _type,
  field,
  object,
  refetch,
  collection,
  selectedItem,
  fieldPointer,
  ...options
}) {
  // if (collection.collection === "devices") {
  //   const dateNow = new Date();
  //   const update = new Date(object.update);
  //   const difference = (dateNow - update) / 1000;
  //   const stats = difference > 70 ? "offline" : "online";
  //   object.stats = stats;
  // }
  switch (_type?.toLowerCase() || type?.toLowerCase()) {
    case "email":
    case "string":
    case "text":
    case "number":
    case "tel":
    case "enum":
    case "parsenumber":
    case "decemalnum":
    case "time":
    case "textarea":
      return (
        <OutputString
          field={field}
          object={object}
          refetch={refetch}
          collection={collection}
          {...options}
        />
      );
    case "boolean":
      return <OutputBoolean field={field} object={object} {...options} />;
    case "date":
    case "datetime-local":
      return (
        <OutputDate
          field={field}
          object={object}
          collection={collection}
          {...options}
        />
      );
    case "image":
      return <OutputImage field={field} object={object} {...options} />;
    case "pointer":
    case "empointer":
    case "inputpointer":
      return (
        <OutputPointer
          field={field}
          object={object}
          {...options}
          fieldPointer={fieldPointer}
        />
      );
    case "related":
      return <OutputRelation field={field} object={object} {...options} />;
    case "component":
      return object[field];
    case "array":
    case "antrelation":
      return (
        <OutputArray
          field={field}
          object={object}
          {...options}
          selectedItem={selectedItem}
          collection={collection}
        />
      );
    default:
      return null;
  }
}

export default OutputFactory;
